import { render, staticRenderFns } from "./featuredPosts.vue?vue&type=template&id=0a1660a8&scoped=true"
import script from "./featuredPosts.vue?vue&type=script&lang=js"
export * from "./featuredPosts.vue?vue&type=script&lang=js"
import style0 from "./featuredPosts.vue?vue&type=style&index=0&id=0a1660a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a1660a8",
  null
  
)

export default component.exports